<template>
  <el-tooltip :content="title" placement="top" :open-delay="200">
    <span class="status-icon" :class="iconClass">
      <i v-if="elIconName" :class="elIconName"></i>
      <span v-else class="status-icon__text">{{ iconText }}</span>
    </span>
  </el-tooltip>
</template>

<script>
export default {
  name: 'StatusIcon',
  props: {
    type: {
      type: String,
      required: true,
      validator: val => ['rain', 'simultaneous', 'continuous', 'temp', 'recovered', 'not-recovered', 'spike'].includes(val),
    },
    title: {
      type: String,
      default: '',
    },
  },
  computed: {
    iconClass() {
      return `status-icon--${this.type}`;
    },
    elIconName() {
      const map = {
        'continuous': 'el-icon-refresh',
        'recovered': 'el-icon-check',
        'not-recovered': 'el-icon-close',
      };
      return map[this.type] || null;
    },
    iconText() {
      const map = {
        'rain': '雨',
        'simultaneous': '同',
        'temp': '溫',
        'spike': '突',
      };
      return map[this.type] || '';
    },
  },
};
</script>

<style scoped>
.status-icon {
  display: inline-flex;
  align-items: center;
  justify-content: center;
  width: 18px;
  height: 18px;
  border-radius: 50%;
  font-size: 10px;
  cursor: help;
  flex-shrink: 0;
}

.status-icon i {
  font-size: 10px;
  font-weight: bold;
}

.status-icon__text {
  font-size: 9px;
  font-weight: 600;
  line-height: 1;
}

.status-icon--rain {
  background-color: #dbeafe;
  color: #2563eb;
}

.status-icon--simultaneous {
  background-color: #f3e8ff;
  color: #9333ea;
}

.status-icon--continuous {
  background-color: #cffafe;
  color: #0891b2;
}

.status-icon--temp {
  background-color: #fef3c7;
  color: #d97706;
}

.status-icon--recovered {
  background-color: #dcfce7;
  color: #16a34a;
}

.status-icon--not-recovered {
  background-color: #fee2e2;
  color: #dc2626;
}

.status-icon--spike {
  background-color: #ffe4e6;
  color: #e11d48;
}
</style>